import { Component, Input, ViewChild, ElementRef } from "@angular/core";
import { CompanyDataService } from "../company-data.service";
//access store
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Dictionary } from "src/app/store/models/common_types";
import { CompanyPageMeta } from "src/app/store/models/company-page-store.model";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  PreviewDataForSellsideUsersResponse,
  PreviewDataForSellsideUsersError,
} from "../company-page.model";
import { AppService } from "../../app.service";
import { Observable } from "rxjs";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  VAIconRegistryService,
  exclamationTriangle,
  infoCircle,
} from "@va/core-library/icons";

@Component({
  selector: "app-company-earnings-preview",
  templateUrl: "./company-earnings-preview.component.html",
  styleUrls: ["./company-earnings-preview.component.scss"],
})
export class CompanyEarningsPreviewComponent {
  @Input() ticker: string;
  @Input() quarters: Array<any>;
  @Input() periodRange: Record<string, any>;
  @Input() periodDropdown;
  @Input() showMonitoring;
  @Input() currencyValue;
  earningsPreviewData = {};
  companyName = "";
  isEarningPreviewData = false;
  listOfEmails: Array<any> = [];
  userEmail = "";
  faEnvelope = faEnvelope;
  showEmailText = false;
  earningsPreviewDataReady = false;
  earningPreviewQuarters: Array<any> = [];
  firstPeriodQA;
  firstPeriodYear: number;
  secondPeriodQA;
  secondPeriodYear: number;
  makeCopy: boolean;
  firstDiff = "";
  secondDiff = "";
  keyValuesName: Array<any> = [];
  diff1 = "";
  diff2 = "";
  firstPeriodDiffValue;
  firstPeriodDiff;
  secondPeriodDiffValue;
  secondPeriodDiff;
  firstPeriodForcast;
  firstPeriodConsensus;
  secondPeriodForcast;
  secondPeriodConsensus;
  showSendButton = false;
  showShare = true;
  shareClicked = false;
  headerButtonSpan = "6";
  btnOffset = "10";
  earningsPreviewLen: number;
  meta: any;
  inputEmail = "";
  isValidEmail = true;
  emailInputVisible = false;
  brokerShortName = "";
  analystName = "";
  lastModelDate = "";
  hasError = false;
  emailErrMsg: string;
  @ViewChild("inputElement") inputElement?: ElementRef;
  errMsg = "Something went wrong!";
  dataObservable: Observable<
    PreviewDataForSellsideUsersResponse | PreviewDataForSellsideUsersError
  >;
  periodMappings = {
    q: { values: ["1QFY", "2QFY", "3QFY", "4QFY"], priority: 1 },
    h: { values: ["1HFY", "2HFY"], priority: 2 },
    y: { values: ["Annual"], priority: 0 },
  };

  constructor(
    private service: CompanyDataService,
    private store: Store<AppState>,
    private appService: AppService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle, infoCircle]);
  }

  ngOnInit() {
    this.store
      .select(stateGetter("companyPage", "meta"))
      .subscribe((data: Dictionary<CompanyPageMeta>) => {
        if (data) {
          const meta = data[this.ticker];
          this.companyName = meta.company_name;
          if (meta.user_email) {
            this.userEmail = meta.user_email;
            this.listOfEmails.push(this.userEmail);
          }
        }
      });
    this.dataObservable = this.service.getPreviewDataForSellsideUsers(
      this.ticker,
      undefined,
      undefined,
    );
  }

  createEarningPreviewDropDownList() {
    const keys = Object.keys(this.periodRange);
    const values = keys
      .reduce((p, c) => [...p, this.periodMappings[c]], [])
      .sort((a, b) => a.priority - b.priority)
      .reduce((p, c) => [...p, ...c.values], []);
    this.earningPreviewQuarters = values.map((item) => ({
      name: item,
      value: item,
    }));
  }
  onPreviewDataForSellsideUsersResolved(response) {
    this.earningsPreviewData = response.data;
    this.isEarningPreviewData = true;
    this.meta = this.earningsPreviewData["meta"];
    this.earningsPreviewLen = this.meta.length;
    this.brokerShortName = this.earningsPreviewData["broker_shortname"];
    this.analystName = this.earningsPreviewData["analyst_name"];
    this.lastModelDate = this.earningsPreviewData["last_model_date"];
    this.createEarningPreviewDropDownList();
    // for (let i = 0; i < this.quarters.length; i++) {
    //   const temp = {
    //     name: this.quarters[i],
    //     value: this.quarters[i] === "Annual" ? "FY" : this.quarters[i]
    //   };
    //   this.earningPreviewQuarters.push(temp);
    // }
    const period = this.earningsPreviewData["period1"].split("-");
    let qa = {};
    for (let i = 0; i < this.earningPreviewQuarters.length; i++) {
      if (this.earningPreviewQuarters[i].value === period[0]) {
        qa = this.earningPreviewQuarters[i];
        break;
      }
    }
    this.firstPeriodQA = qa;
    this.firstPeriodYear = parseInt(period[1]);
    this.firstDiff = "Diff (%)";
    this.secondDiff = "Diff (%)";
    this.makeCopy = false;

    const period2 = this.earningsPreviewData["period2"].split("-");
    let qa2 = {};
    for (let i = 0; i < this.earningPreviewQuarters.length; i++) {
      if (this.earningPreviewQuarters[i].value === "Annual")
        this.earningPreviewQuarters[i].value = "FY";
      else this.earningPreviewQuarters[i].value;
      if (this.earningPreviewQuarters[i].value === period2[0]) {
        qa2 = this.earningPreviewQuarters[i];
        break;
      }
    }
    this.secondPeriodQA = qa2;
    this.secondPeriodYear = parseInt(period2[1]);
    this.diff1 = "diff%";
    this.diff2 = "diff%";

    //prepare data for table population

    this.firstPeriodForcast =
      this.earningsPreviewData["values"].broker[
        this.earningsPreviewData["period1"]
      ];
    this.firstPeriodConsensus =
      this.earningsPreviewData["values"].consensus[
        this.earningsPreviewData["period1"]
      ];
    this.firstPeriodDiffValue =
      this.earningsPreviewData["values"].diff[
        this.earningsPreviewData["period1"]
      ];
    this.firstPeriodDiff = {};
    this.secondPeriodForcast =
      this.earningsPreviewData["values"].broker[
        this.earningsPreviewData["period2"]
      ];
    this.secondPeriodConsensus =
      this.earningsPreviewData["values"].consensus[
        this.earningsPreviewData["period2"]
      ];

    this.secondPeriodDiffValue =
      this.earningsPreviewData["values"].diff[
        this.earningsPreviewData["period2"]
      ];
    this.secondPeriodDiff = {};
    this.keyValuesName = [];

    //end
    this.setEarningsFormatted("all", "");
  }

  onFailure(response) {
    if (response.status === "error") {
      this.errMsg = "Sorry, something went wrong.";
    }
  }

  onShareClicked() {
    this.showSendButton = true;
    this.showShare = false;
    this.shareClicked = true;
    this.showEmailText = true;
    this.headerButtonSpan = "3";
    this.btnOffset = "0";
  }

  onSend() {
    const dataToUse = {
      emailids: this.listOfEmails,
      ticker: this.ticker,
      diff_type1: this.diff1,
      diff_type2: this.diff2,
    };
    // const extraData = {
    //   company: this.ticker,
    //   beginning_state_referrer: "Earnings_Preview",
    //   emailIds: dataToUse.emailIds,
    //   lineItems: this.keyValuesName,
    //   period1: this.earningsPreviewData["period1"],
    //   diff1: this.diff1,
    //   period2: this.earningsPreviewData["period2"],
    //   diff2: this.diff2
    // };
    this.service
      .sendPreviewMailForSellsideusers(dataToUse)
      .subscribe((response) => {
        if (response.status === "success") {
          //success message
          this.message.warning(
            `Preview has been sent to ${dataToUse.emailids.join("<br>")}`,
            {
              nzDuration: 2000,
            },
          );
          this.showEmailText = false;
          this.showSendButton = false;
          this.shareClicked = false;
          this.listOfEmails = [];
          this.listOfEmails.push(this.userEmail);
          this.showShare = true;
          this.headerButtonSpan = "6";
          this.btnOffset = "10";
        }
      });
  }

  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }

  handleInputConfirm(): void {
    this.emailErrMsg = "";
    if (this.inputEmail) {
      const emails = this.inputEmail.split(",");
      let isvalid = true;
      for (let i = 0; i < emails.length; i++) {
        const emailValidation = this.appService.verifyEmailAddress(emails[i]);
        const isWarn = emailValidation.hasWarning;
        const isError = emailValidation.hasError;
        if (
          (!isWarn || !isError) &&
          this.listOfEmails.indexOf(emails[i]) === -1
        ) {
          if (this.listOfEmails.length === 5) {
            isvalid = false;
            this.emailErrMsg = "Cannot add more than 5";
            break;
          }
          this.listOfEmails = [...this.listOfEmails, emails[i]];
          this.inputEmail = "";
        } else isvalid = false;
      }
      this.isValidEmail = isvalid;
      if (!this.emailErrMsg.length) {
        this.emailErrMsg = "Invalid email id";
      }
    } else {
      this.isValidEmail = false;
      this.emailErrMsg = "Please enter an email id";
    }
  }

  showInput(): void {
    this.emailInputVisible = true;
    setTimeout(() => {
      if (this.inputElement) {
        this.inputElement.nativeElement.focus();
      }
    }, 10);
  }

  handleClose(removedTag) {
    this.listOfEmails = this.listOfEmails.filter((tag) => tag !== removedTag);
  }

  estimatedPeriodChange(event, col) {
    if (!event) {
      event = "estimatedPeriodchangeevent";
    }
    //this[changedVar].value = val;
    let period = "";
    if (col === "1") {
      period = `${this.firstPeriodQA.value}-${this.firstPeriodYear}`;
      this.earningsPreviewData["period1"] = period;
    } else {
      period = `${this.secondPeriodQA.value}-${this.secondPeriodYear}`;
      this.earningsPreviewData["period2"] = period;
    }
    // if(this.canceler)
    //     this.canceler.resolve();
    // var jsonData={
    //     "ticker":this.ticker,
    //     "companyhomepage": true
    // }
    const extraData = {
      company: this.ticker,
      beginning_state_referrer: "Earnings_Preview",
    };
    //this.canceler = $q.defer();
    this.service
      .getPreviewDataForSellsideUsers(this.ticker, period, col)
      .subscribe(
        (response: PreviewDataForSellsideUsersResponse) => {
          //success toaster
          if (response.status === "success") {
            if (col === "1") {
              //prepare data for table population
              this.firstPeriodForcast =
                response.data.values.broker[
                  this.earningsPreviewData["period1"]
                ];
              this.firstPeriodConsensus =
                response.data.values.consensus[
                  this.earningsPreviewData["period1"]
                ];
              //change this
              this.firstPeriodDiffValue =
                response.data.values.diff[this.earningsPreviewData["period1"]];
              extraData["period1"] = period;
            } else {
              this.secondPeriodForcast =
                response.data.values.broker[
                  this.earningsPreviewData["period2"]
                ];
              this.secondPeriodConsensus =
                response.data.values.consensus[
                  this.earningsPreviewData["period2"]
                ];
              this.secondPeriodDiffValue =
                response.data.values.diff[this.earningsPreviewData["period2"]];
              extraData["period2"] = period;
            }
            this.setEarningsFormatted("period", col);

            this.appService.logUserAction(
              event,
              this.ticker,
              "",
              "Earnings_Preview",
              extraData,
              "",
              "Earnings_Preview_Edit",
            );
          }
        },
        (err) => {
          console.error(err);
          this.hasError = true;
        },
        //error callback
      );
  }

  setEarningsFormatted(update, col) {
    for (let i = 0; i < this.earningsPreviewData["meta"].length; i++) {
      const row = this.earningsPreviewData["meta"][i];
      if (update === "all") {
        row.unitSymbol = row.unit === "%" ? "bps" : "%";
        row.setPercent = row.currency === "" && row.unit === "%";
        row.header = row.name;
        this.keyValuesName.push(row.header);
        if (row.display_unit !== this.currencyValue) {
          row.header = `${row.name} (${row.display_unit})`;
        }
      }
      //when first period is changed
      if (col === "1" || update === "all") {
        if (!this.firstPeriodForcast[row.dpid]) {
          this.firstPeriodForcast[row.dpid] = { value: "NA" };
        }
        this.firstPeriodForcast[row.dpid] = this.getFormat(
          this.firstPeriodForcast[row.dpid].value,
          true,
        );

        if (!this.firstPeriodConsensus[row.dpid]) {
          this.firstPeriodConsensus[row.dpid] = { value: "NA" };
        }
        this.firstPeriodConsensus[row.dpid] = this.getFormat(
          this.firstPeriodConsensus[row.dpid].value,
          true,
        );

        if (!this.firstPeriodDiffValue[row.dpid]) {
          this.firstPeriodDiffValue[row.dpid] = {
            "diff#": "NA",
            "diff%": "NA",
          };
        }
        this.firstPeriodDiff[row.dpid] = this.getFormat(
          this.firstPeriodDiffValue[row.dpid][this.diff1],
          true,
        );
      }
      //when second period is changed
      if (col === "2" || update === "all") {
        if (!this.secondPeriodForcast[row.dpid]) {
          this.secondPeriodForcast[row.dpid] = { value: "NA" };
        }
        this.secondPeriodForcast[row.dpid] = this.getFormat(
          this.secondPeriodForcast[row.dpid].value,
          true,
        );

        if (!this.secondPeriodConsensus[row.dpid]) {
          this.secondPeriodConsensus[row.dpid] = { value: "NA" };
        }
        this.secondPeriodConsensus[row.dpid] = this.getFormat(
          this.secondPeriodConsensus[row.dpid].value,
          true,
        );

        if (!this.secondPeriodDiffValue[row.dpid]) {
          this.secondPeriodDiffValue[row.dpid] = {
            "diff#": "NA",
            "diff%": "NA",
          };
        }
        this.secondPeriodDiff[row.dpid] = this.getFormat(
          this.secondPeriodDiffValue[row.dpid][this.diff2],
          true,
        );
      }
    }
    this.earningsPreviewDataReady = true;
  }
  getFormat(val, checkZero) {
    const valueObj = {
      class: false,
      value: val,
      isNA: false,
    };
    if (val === "NA") {
      valueObj.value = val;
      valueObj.isNA = true;
      return valueObj;
    }
    if (checkZero && parseFloat(val) === 0) {
      return valueObj;
    }
    // if row contains negative number
    if (parseFloat(val) < 0) {
      // add class "negative"
      valueObj.class = true;
      valueObj.value = Math.abs(val);
    } else if (parseFloat(val) >= 0) {
      // add class "positive"
      valueObj.class = false;
      valueObj.value = val;
    }
    return valueObj;
  }

  estimateDiffChange(event, col, val) {
    if (!event) {
      event = "estimateDiffchangeevent";
    }
    const extraData = {
      company: this.ticker,
      beginning_state_referrer: "Earnings_Preview",
    };
    if (col === "1") {
      this.diff1 = val;
      extraData["diff1"] = val;
      if (val === "diff%") this.firstDiff = "Diff (%)";
      else this.firstDiff = "Diff (#)";
      for (let i = 0; i < this.earningsPreviewData["meta"].length; i++) {
        const row = this.earningsPreviewData["meta"][i];
        if (!this.firstPeriodDiffValue[row.dpid]) {
          this.firstPeriodDiffValue[row.dpid] = {
            "diff#": "NA",
            "diff%": "NA",
          };
        }
        this.firstPeriodDiff[row.dpid] = this.getFormat(
          this.firstPeriodDiffValue[row.dpid][this.diff1],
          true,
        );
      }
    } else {
      this.diff2 = val;
      extraData["diff2"] = val;
      if (val === "diff%") this.secondDiff = "Diff (%)";
      else this.secondDiff = "Diff (#)";
      for (let i = 0; i < this.earningsPreviewData["meta"].length; i++) {
        const row = this.earningsPreviewData["meta"][i];
        if (!this.secondPeriodDiffValue[row.dpid]) {
          this.secondPeriodDiffValue[row.dpid] = {
            "diff#": "NA",
            "diff%": "NA",
          };
        }
        this.secondPeriodDiff[row.dpid] = this.getFormat(
          this.secondPeriodDiffValue[row.dpid][this.diff2],
          true,
        );
      }
    }
    this.appService.logUserAction(
      event,
      this.ticker,
      "",
      "Earnings_Preview",
      extraData,
      "",
      "Earnings_Preview_Edit",
    );
  }
}
